import { render, staticRenderFns } from "./HisInfoTextBoxObject.vue?vue&type=template&id=94861e80&scoped=true&"
import script from "./HisInfoTextBoxObject.vue?vue&type=script&lang=ts&"
export * from "./HisInfoTextBoxObject.vue?vue&type=script&lang=ts&"
import style0 from "./HisInfoTextBoxObject.vue?vue&type=style&index=0&id=94861e80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94861e80",
  null
  
)

export default component.exports